import { metricKeys } from '@pulse/metrics';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import {
  OPPORTUNITY_METRICS_CATEGORY,
  BM_SUPPORTED_DIMENSIONS,
  BM_DIMENTIONS_MAPPING,
  BM_SUPPORTED_ADVANCED_DIMENSIONS,
  IMPROVEMENT_OPPORTUNITY_ADMETRICS,
  EIThresholdsMeta,
  OVERVIEW_AUDIENCE_METRICS,
  DEFAULT_DIMENSIONS,
  WIDGET_TYPES,
  DEFAULT_FILTER,
  DISABLE_UNIT_TOGGLE_METRICS,
  VIDEO_CREATE_NEW_SPI_CONFIG,
  VIDEO_DEFAULT_KPI_CONFIG,
  SPI_BEST_METRICS,
  METRIC_WIDGET_METRICS,
  KPI_DIMENSIONS_MAP,
  KPI_DIMENSION_METRICS,
} from './ei';
import { APP_CREATE_NEW_SPI_CONFIG, APP_DEFAULT_KPI_CONFIG } from './app';

const SYSTEM_DEFINED_SPI_IDS_CONFIG = {
  EI: [1, 2],
  APP: [5],
};

const ALLOWED_KPIS_NUMBER = 12; // 2 + 10
const ALLOWED_CUSTOM_KPI_LIMIT = 10;
const LIMIT_TEXT = `You can only create ${ALLOWED_CUSTOM_KPI_LIMIT} custom KPIs.`;
const CONVIVA_MODE_TEXT = 'You cannot edit/delete system defined KPIs.';

const DEFAULT_KPI_ID_CONFIG = {
  EI: 1,
  APP: 5,
};

const ThresholdsMetaConfig = {
  EI: EIThresholdsMeta,
  APP: {},
  AI: {},
};

const IMPROVEMENT_OPPORTUNITY_METRICS_LIST = {
  EI: [
    ...OPPORTUNITY_METRICS_CATEGORY.STARTUP_FAIL,
    ...OPPORTUNITY_METRICS_CATEGORY.PLAYBACK_ISSUES,
  ],
  APP: [
    metricKeys.AppSPIHighScreenLoadRate,
    metricKeys.AppSPIHighPageLoadRate,
    metricKeys.AppSPIHighAppStartupRate,
    metricKeys.AppSPIAppCrashSessionRate,
  ],
  AI: [],
};

const CREATE_NEW_SPI_CONFIG_MAP = {
  EI: VIDEO_CREATE_NEW_SPI_CONFIG,
  APP: APP_CREATE_NEW_SPI_CONFIG,
  AI: {},
};

const DEFAULT_KPI_CONFIG_MAP = {
  EI: {
    ...VIDEO_DEFAULT_KPI_CONFIG,
  },
  APP: {
    ...APP_DEFAULT_KPI_CONFIG,
  },
  AI: {},
};

const OVERVIEW_LABELS = {
  ACTIVE_KPI_DELETE_CONFIRMATION:
    'Deleting this will remove this KPI for all the users and the default KPI preference will be set to Conviva Good. Are you sure you want to proceed?',
  OTHER_KPI_DELETE_CONFIRMATION:
    'Deleting this will remove the KPI for all the users in the account. Are you sure you want to proceed?',
  ERROR_CREATE_NEW: `User is not allowed to have more than ${ALLOWED_CUSTOM_KPI_LIMIT} custom KPIs. Please delete a few to create new KPIs.`,
  ERROR_KPI_MAX_LENGTH: 'KPI name exceeds the maximum length.',
  ERROR_KPI_DUPLICATE: 'KPI Names have to be unique.',
  ERROR_KPI_EMPTY: 'KPI Name cannot be empty.',
};

const SYSTEM_DEFINED_SPI_IDS = SYSTEM_DEFINED_SPI_IDS_CONFIG[CURRENT_PRODUCT_MODE];
const DEFAULT_KPI_ID = DEFAULT_KPI_ID_CONFIG[CURRENT_PRODUCT_MODE];
const ThresholdsMeta = ThresholdsMetaConfig[CURRENT_PRODUCT_MODE];
const IMPROVEMENT_OPPORTUNITY_METRICS = IMPROVEMENT_OPPORTUNITY_METRICS_LIST[CURRENT_PRODUCT_MODE];
const CREATE_NEW_SPI_CONFIG = CREATE_NEW_SPI_CONFIG_MAP[CURRENT_PRODUCT_MODE];
const DEFAULT_KPI_CONFIG = DEFAULT_KPI_CONFIG_MAP[CURRENT_PRODUCT_MODE];

export {
  METRIC_WIDGET_METRICS,
  OVERVIEW_LABELS,
  KPI_DIMENSIONS_MAP,
  KPI_DIMENSION_METRICS,
  SYSTEM_DEFINED_SPI_IDS,
  ALLOWED_KPIS_NUMBER,
  DEFAULT_KPI_ID,
  OPPORTUNITY_METRICS_CATEGORY,
  BM_DIMENTIONS_MAPPING,
  BM_SUPPORTED_ADVANCED_DIMENSIONS,
  BM_SUPPORTED_DIMENSIONS,
  IMPROVEMENT_OPPORTUNITY_METRICS,
  IMPROVEMENT_OPPORTUNITY_ADMETRICS,
  ThresholdsMeta,
  OVERVIEW_AUDIENCE_METRICS,
  DEFAULT_DIMENSIONS,
  WIDGET_TYPES,
  DEFAULT_FILTER,
  DISABLE_UNIT_TOGGLE_METRICS,
  CREATE_NEW_SPI_CONFIG,
  DEFAULT_KPI_CONFIG,
  SPI_BEST_METRICS,
  LIMIT_TEXT,
  CONVIVA_MODE_TEXT,
};
